import { ReactElement } from 'react';
import { ValueLabel, variables } from '../common';
import { ICsaRequestStatus, showCsa } from '.';
import { map as lmap, compose as lcompose } from 'lodash/fp';
import { left, right, fold } from 'fp-ts/lib/Either';
import { styled } from '@mui/material';

export const renderCsaStack =
  (s: any) => (properties: ValueLabel<keyof ICsaRequestStatus>[]) =>
    lcompose(
      fold(
        () => <article>Empty</article>,

        requests => (
          <Wrapper>
            {lmap<ICsaRequestStatus, ReactElement>(a => (
              <ItemWrapper key={a.id}>
                {lmap<ValueLabel<keyof ICsaRequestStatus>, ReactElement>(
                  ({ value, label }) => (
                    <Line key={value}>
                      <Label>{label}:</Label>
                      <Label>{showCsa(value)(a)}</Label>
                    </Line>
                  )
                )(properties)}
              </ItemWrapper>
            ))(requests)}
          </Wrapper>
        )
      ),
      (requests: ICsaRequestStatus[]) =>
        requests.length === 0 ? left(requests) : right(requests)
    );

const Wrapper = styled('article')(() => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },
}));

const ItemWrapper = styled('article')(() => ({
  display: 'flex',
  flexDirection: 'column',

  '&>*+*': {
    marginTop: '0.5rem',
  },
  paddingBottom: '0.5rem',
  borderBottom: variables.cardBorder,
}));

const Line = styled('span')(() => ({
  maxHeight: '10em',
  overflow: 'auto',

  '&>*+*': {
    marginLeft: '1rem',
  },
}));

const Label = styled('span')(() => ({
  fontWeight: 700,
}));
